// Business setting: how reconciliation dates transactions. Switching never
// changes stored dates or reconciled months; it applies to open months.
import React, { useEffect, useState } from 'react';
import reconciliationAPI from './services/reconciliationApi';
import { formatApiError } from '../../utils/errorMessage';

export const DATING_OPTIONS = [
  { value: 'transaction_date', label: 'Transaction date (uncleared items carry forward as outstanding)' },
  { value: 'bank_posted_date', label: 'Bank posted date (items count in the month they are dated)' }
];

export default function DatingMethodSetting({ businessId }) {
  const [value, setValue] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    let live = true;
    if (!businessId) return undefined;
    reconciliationAPI.getDatingMethod(businessId)
      .then((res) => { if (live) setValue(res.data.reconciliation_dating_method); })
      .catch((e) => { if (live) setError(formatApiError(e, 'Could not load the reconciliation setting')); });
    return () => { live = false; };
  }, [businessId]);
  const change = async (next) => {
    setSaving(true); setError('');
    try { setValue((await reconciliationAPI.setDatingMethod(businessId, next)).data.reconciliation_dating_method); } catch (e) { setError(formatApiError(e, 'Could not save the reconciliation setting')); }
    setSaving(false);
  };
  if (!businessId || !value) return error ? <p role="alert" className="text-red-600 text-xs">{error}</p> : null;
  return (
    <label className="block text-sm mb-3">
      Reconciliation dating
      <select value={value} disabled={saving} onChange={(e) => change(e.target.value)} className="block border rounded px-2 py-1 text-sm" aria-label="Reconciliation dating">
        {DATING_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      <span className="text-xs text-gray-500">Changing this only affects months that are not reconciled yet.</span>
      {error && <span role="alert" className="text-red-600 text-xs block">{error}</span>}
    </label>
  );
}